import script from "./WritingBoardTool.vue?vue&type=script&lang=ts&setup=true"
export * from "./WritingBoardTool.vue?vue&type=script&lang=ts&setup=true"

import "./WritingBoardTool.vue?vue&type=style&index=0&id=4a5c9518&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a5c9518"]])

export default __exports__